import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { getOtherChargesTotal, formatCurrency } from '../ricFormUtils';
import { ChargeTableType } from '../ricFormTypes';
import { ChargeTable, SectionItem, SubsectionItem } from '../Components';

const SchemaChargeTable = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement,
}: {
  formElement: ChargeTableType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const {
    title,
    subtitle,
    responseDataField,
    columns,
    displayTotalValue,
    options = {},
    defaultDescriptions,
  } = formElement;
  const { hideAmountInputs } = options;
  const HeaderComponent = isSubSectionElement ? SubsectionItem : SectionItem;
  const value = displayTotalValue
    ? formatCurrency(
        getOtherChargesTotal(responseData?.[responseDataField] ?? []),
      )
    : null;
  return (
    <>
      <HeaderComponent title={title} subtitle={subtitle} value={value} />
      <ChargeTable
        columns={columns}
        responseData={responseData}
        responseDataField={responseDataField}
        onChange={fetchResponseWithUpdatedData}
        hideAmountInputs={hideAmountInputs}
        defaultDescriptions={defaultDescriptions}
      />
    </>
  );
};

export default SchemaChargeTable;
